export default {"src":"/_next/static/media/ehr-application.1df20c9b.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};